import { render, staticRenderFns } from "./GinaParameter.vue?vue&type=template&id=0328af56&"
import script from "./GinaParameter.vue?vue&type=script&lang=js&"
export * from "./GinaParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports